import api from './api';

export const memberService = {
  async getMembers(params = {}) {
    const response = await api.get('/members', { params });
    return response.data;
  },

  async getMemberById(id) {
    const response = await api.get(`/members/${id}`);
    return response.data;
  },

  async createMember(memberData) {
    const response = await api.post('/members', memberData);
    return response.data;
  },

  async updateMember(id, memberData) {
    const response = await api.put(`/members/${id}`, memberData);
    return response.data;
  },

  async deleteMember(id) {
    const response = await api.delete(`/members/${id}`);
    return response.data;
  },

  async searchMembers(query, filters = {}) {
    const response = await api.get('/members/search', { params: { q: query, ...filters } });
    return response.data;
  },

//   async searchMembers(query) {
//     const response = await api.get('/members/search', { params: { q: query } });
//     return response.data;
//   },

  async approveMember(id) {
    const response = await api.post(`/members/${id}/approve`);
    return response.data;
  },

  async verifyNid(id, nid) {
    const response = await api.post(`/members/${id}/verify-nid?nid_number=${nid}`);
    return response.data;
  },

  async getPendingMembers() {
    const response = await api.get('/members/pending');
    return response.data;
  },

  async getMemberDashboard(id) {
    const response = await api.get(`/members/${id}/dashboard`);
    return response.data;
  },

  async transferMember(id, transferData) {
    const response = await api.post(`/members/${id}/transfer`, transferData);
    return response.data;
  }
};